import { heatReportColors } from "../theme/colors";

const { status } = heatReportColors;

export const getHeatStatus = (heatStatus: string) => {
  switch (heatStatus) {
    case "S":
      return { name: "Scheduled", color: status.scheduled, letter: "S" };
    case "M":
      return { name: "Melting", color: status.melting, letter: "M" };
    case "T":
      return { name: "Tapped", color: status.tapped, letter: "T" };
    case "O":
      return { name: "Opened", color: status.opened, letter: "O" };
    case "C":
      return { name: "Closed", color: status.closed, letter: "C" };
    case "R":
      return { name: "Returned", color: status.returned, letter: "R" };
    case "F":
      return { name: "Finished", color: status.finished, letter: "F" };
    default:
      return { name: "Unknown", color: status.unknown, letter: "X" };
  }
};
